// extracted by mini-css-extract-plugin
export default {"actions":"FieldInlineActions_actions__RB44a","action":"FieldInlineActions_action__citfI"};